export default {
    CHANGE_ZOOM(state, histoWf) {
        state.histoWf = histoWf;
      },
};